<template>
  <div>
    <h4 class="text-center">RCS Business Messages</h4>

    <div class="mt-5">
      <form @submit.prevent="promiseConnect = connect()">
        <div class="form-group row">
          <label class="col-4 text-muted col-form-label">
            Choose an Agent Name:
          </label>
          <div class="col-8">
            <input class="form-control"
                   :class="{'is-invalid': serverErrorMessage}"
                   placeholder="My Company"
                   v-model="agentName"
                   maxlength="50"/>
            <div v-show="serverErrorMessage" class="invalid-feedback">
              {{ serverErrorMessage }}
            </div>
          </div>
        </div>

        <div>
          <b-button v-b-toggle.collapse-1
                    class="mt-4 pl-0"
                    variant="link"><icon class="btn-icon" name="question-circle" scale="1.0"></icon><span class="small">What is Agent Name?</span></b-button>

          <b-collapse id="collapse-1" class="mt-2">
            <b-card class="bg-light">
              <p class="m-2 text-muted">
                Agent Name is displayed in the <a href="https://messages.google.com">Messages app</a>  as the sender of your messages.
              </p>

              <div class="d-flex">
                <img class="my-2 mx-auto" src="../../../../../assets/img/channel_wizard/rbm/mockup_rbm_cutoff.png"/>
              </div>
            </b-card>
          </b-collapse>
        </div>

        <div class="row mt-5">
          <div class="col-12 d-flex justify-content-center">
            <button class="btn btn-primary px-5"
                    v-busy-button="promiseConnect">
              Create
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
  import channelService from '@/services/amio-api/channel.service'
  import 'vue-awesome/icons/question-circle'

  export default {
    data() {
      return {
        promiseConnect: null,
        agentName: '',
        serverErrorMessage: ''
      }
    },

    methods: {
      connect() {
        this.clearError()
        const data = {
          type: 'rbm',
          rbm: {
            agent_name: this.agentName
          }
        }
        return channelService.create(data, [422])
          .then(channel => {
            this.channel = channel
            this.$router.push({name: 'administration.channel-detail.info', params: {id: channel.id}})
          })
          .catch((err) => {
            if (err.response.status !== 422) return

            const error = err.response.data.errors ? err.response.data.errors[0] : {}
            this.handleError(error)
          })
          .then(() => {
            this.promiseConnect = null
          })
      },

      clearError() {
        this.serverErrorMessage = ''
      },

      handleError(error) {
        this.serverErrorMessage = error.message
      }
    }
  }
</script>
